export const BASE_URL = "https://restnode-prd.unidatanet.com.br/";
//export const BASE_URL = "https://restnode-qas.unidatanet.com.br/";
//export const BASE_URL = "http://10.10.40.60:3000";
export const BASE_URL_PDF_EXCEL = "https://ws.unidatanet.com.br/faturamento-rad-prd/";
//export const BASE_URL_PDF_EXCEL = "http://rad-qas.unidatanet.com.br:8080/faturamento-rad-qas/";
export const SHOW_ALERT = "SHOW_ALERT";
export const HIDE_ALERT = "HIDE_ALERT";
export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const CLEAR_MODAL = "CLOSE_MODAL";
export const TOOGLE_DRAWER = "TOOGLE_DRAWER";
export const TOOGLE_DRAWER_RESPONSIVO = "TOOGLE_DRAWER_RESPONSIVO";
export const SET_SELECTED_MENU = "SET_SELECTED_MENU";
export const SET_COLLAPSED_MENU = "SET_COLLAPSED_MENU";
export const TOOGLE_LOADING = "TOOGLE_LOADING";
export const SET_COLUNA_FILTRO_MOBILE = "SET_COLUNA_FILTRO_MOBILE";
export const REMOVE_COLUNA_FILTRO_MOBILE = "REMOVE_COLUNA_FILTRO_MOBILE";
export const SET_COLUNAS_MOBILE = "SET_COLUNAS_MOBILE";
export const LIMPA_FILTROS_MOBILE = "LIMPA_FILTROS_MOBILE";
